import React from "react";
import { Image, TouchableOpacity, View, Text, StyleSheet } from "react-native";
import { useNavigation } from "@react-navigation/native";
import * as Progress from 'react-native-progress';

const TaskItem = ({ task, handleDelete }) => {
  const navigation = useNavigation();

  return (
    <View style={styles.itemContainer}>
      <TouchableOpacity
      >
        <Text style={styles.itemTitle}>{task.title}</Text>
        <Text style={{ color: "#8395a7", paddingLeft: 5, textAlign: "left" }}>{task.description}</Text>
        <Text style={{ color: "#8395a7", paddingLeft: 5, textAlign: "left" }}>{task.code}</Text>
        <Text style={{ color: "#8395a7", paddingLeft: 5, textAlign: "left" }}>{task.advance}</Text>
        <Progress.Bar progress={(task.advance/100)} width={200} />
        <Text style={{ color: "#8395a7", paddingLeft: 5, textAlign: "left" }}>{task.sysdate}</Text>

      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  itemContainer: {
    backgroundColor: "#252138",
    padding: 15,
    paddingRight: 5,
    paddingLeft: 5,
    marginVertical: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "left",
    borderRadius: 5,
  },
  itemTitle: {
    color: "#ffffff",
    paddingRight: 5,
    paddingLeft: 5,
    textAlign: "left"
  }
});
export default TaskItem;
